import { useMemo } from 'react';
import { useAppSelector } from '../redux/hooks';
import { extractFollowedCompaniesFromUserState, type FollowedCompany } from '../utils/user-state/extract-followed-companies-from-user-state';

export function useFollowedCompanies(): FollowedCompany[] {
  const entries = useAppSelector((state) => state.userState?.entries ?? {});
  return useMemo(() => extractFollowedCompaniesFromUserState(entries), [entries]);
}
